import { api } from '../api.js';
import { resolveDataTenantId } from '../utils/platformViewTenant.js';

function tenantId() {
  return resolveDataTenantId();
}

const noCache = { headers: { 'Cache-Control': 'no-cache', Pragma: 'no-cache' } };

export const smartFarmCockpitApi = {
  /** 我的农场 — 农场概况（治理 + 亩数 + IoT） */
  getMyFarmSummary: (tenant = tenantId()) =>
    api.get('/smart-farm-cockpit/my-farm-summary', {
      params: { tenantId: tenant, _t: Date.now() },
      ...noCache,
    }),

  /** 我的农场 — 地块信息表（地块管理中心 /land-parcels 同源） */
  getMyFarmParcels: (tenant = tenantId()) =>
    api.get('/smart-farm-cockpit/my-farm-parcels', {
      params: { tenantId: tenant, _t: Date.now() },
      ...noCache,
    }),

  /** 四情监测 · 墒情 Tab（地块/探针/实时指标/曲线/对比/建议） */
  getFourqingSoil: ({ tenantId: tenant = tenantId(), farmId, parcelId, deviceId } = {}) =>
    api.get('/smart-farm-cockpit/fourqing-soil', {
      params: {
        tenantId: tenant,
        ...(farmId ? { farmId } : {}),
        ...(parcelId ? { parcelId } : {}),
        ...(deviceId ? { deviceId } : {}),
        _t: Date.now(),
      },
      ...noCache,
    }),

  /** 四情监测 · 苗情 Tab（FieldVision 苗情等级热力 + 历史快照时间轴） */
  getFourqingCrop: ({ tenantId: tenant = tenantId(), farmId, parcelId } = {}) =>
    api.get('/smart-farm-cockpit/fourqing-crop', {
      params: {
        tenantId: tenant,
        ...(farmId ? { farmId } : {}),
        ...(parcelId ? { parcelId } : {}),
        _t: Date.now(),
      },
      ...noCache,
    }),

  getPanorama: (farmId, tenant = tenantId()) =>
    api.get('/smart-farm-cockpit/panorama', { params: { farmId, tenantId: tenant } }),

  getRemoteControlCapability: () => api.get('/smart-farm-cockpit/remote-control-capability'),

  zoneRemoteControl: (payload = {}) =>
    api.post('/smart-farm-cockpit/zone-remote-control', { tenantId: tenantId(), ...payload }),

  getFertigationZones: (farmId, tenant = tenantId()) =>
    api.get('/smart-farm-cockpit/fertigation-zones', { params: { farmId, tenantId: tenant } }),

  /** 自有气象站（IoT）实况与近 24h 遥测 */
  getFieldWeather: (farmId, tenant = tenantId()) =>
    api.get('/smart-farm-cockpit/field-weather', {
      params: {
        ...(farmId ? { farmId } : {}),
        tenantId: tenant,
        _t: Date.now(),
      },
      ...noCache,
    }),

  getZoneDetail: ({ farmId, parcelId, recordPage = 0, recordSize = 5, tenantId: tenant = tenantId() }) =>
    api.get('/smart-farm-cockpit/zone-detail', {
      params: { farmId, parcelId, tenantId: tenant, recordPage, recordSize, _t: Date.now() },
      ...noCache,
    }),

  /** 地块电磁阀列表（开度/电量/阀口） */
  getZoneValves: ({ farmId, parcelId, tenantId: tenant = tenantId() } = {}) =>
    api.get('/smart-farm-cockpit/zone-valves', {
      params: {
        ...(farmId ? { farmId } : {}),
        parcelId,
        tenantId: tenant,
        _t: Date.now(),
      },
      ...noCache,
    }),

  /** 无人机巡田 — 设备列表与任务/回传/媒体聚合 */
  getDroneOverview: (tenant = tenantId()) =>
    api.get('/smart-farm-cockpit/drone-overview', {
      params: { tenantId: tenant, _t: Date.now() },
      ...noCache,
    }),
};
